import { fetchBackend } from './apiClient';

export const generateJwtToken = async (projectId: string): Promise<string> => {
  const path = `/jwt/generate/${projectId}`;

  const response = await fetchBackend(path, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Error generating JWT: ${response.status} err: ${response.statusText}`,
    );
  }

  const { token } = await response.json();

  return token as string;
};
